import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { ConfiguredPartner } from '@savgroup-front-common/types/Onboarding/ConnectedPartner';

const ENDPOINT = `${APIConfiguration.seller}ConfiguredPartner`;

interface GetConfiguredPartnersQueryPayload {
  sellerId: string;
}

const getConfiguredPartnersQuery = async ({
  sellerId,
}: GetConfiguredPartnersQueryPayload): Promise<
  BackResponse<ConfiguredPartner[]> | BackResponseFailure
> => {
  try {
    const url = buildUrl(ENDPOINT, {
      sellerId,
    });

    const response = await apiCall<BackResponse<ConfiguredPartner[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getConfiguredPartnersQuery;
